import { atom } from 'jotai';

export const shouldShowRegionLoaderAtom = atom<boolean>(false);
